import React from 'react'
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';


class aboutAll extends Component {
    render() {
        const {aboutAllContent} = this.props
        return (
            <section style={{ paddingTop: 0 }}>
                <div>
                    <div className="breadcrumb-section" style={{
                        background: 'var(--theme-color)',
                        color: 'white'
                    }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="page-title" style={{ display: 'block', textAlignLast: 'center' }}>
                                        <div>Home</div>
                                        <h2 style={{ color: 'white' }}>About Store</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">

                        <div className='row'>
                            <div className='col-md-6'>

                                <img style={{ padding: '50px 0 0 0', width: '100%' }} src='https://giantindia.com/wp-content/uploads/2019/09/advanced-composite.jpg' />
                            </div>
                            <div className='col-md-6'>
                                <div className='row'>
                                    <div className='col-sm-6'>
                                        <img style={{ padding: '50px 0 30px 0' }} src='https://giantindia.com/wp-content/uploads/2019/09/advancedcompositebw_1507879431-200x116.jpg' />
                                    </div>
                                    <div className='col-sm-6'></div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm'>
                                        <h2 style={{lineHeight:'inherit'}}>ADVANCED COMPOSITE TECHNOLOGY
                                        </h2>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm'>
                                        Giant’s High Performance Grade raw carbon material is used to produce this custom frame material in our own composite factory with a high stiffness-to-weight ratio. The front triangle of these framesets is assembled and molded as one continuous piece in a proprietary manufacturing process called Modified Monocoque Construction.


                                    </div>
                                </div>

                            </div>

                        </div>
                        <br/>
                        <br/>
                        <div className='row'>
                            <div className='col-md-6'>

                                <img style={{ padding: '50px 0 0 0', width: '100%' }} src='https://giantindia.com/wp-content/uploads/2019/09/advanced-composite.jpg' />
                            </div>
                            <div className='col-md-6'>
                                <div className='row'>
                                    <div className='col-sm-6'>
                                        <img style={{ padding: '50px 0 30px 0' }} src='https://giantindia.com/wp-content/uploads/2019/09/advancedcompositebw_1507879431-200x116.jpg' />
                                    </div>
                                    <div className='col-sm-6'></div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm'>
                                        <h2 style={{lineHeight:'inherit'}}>ADVANCED COMPOSITE TECHNOLOGY
                                        </h2>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-sm'>
                                        Giant’s High Performance Grade raw carbon material is used to produce this custom frame material in our own composite factory with a high stiffness-to-weight ratio. The front triangle of these framesets is assembled and molded as one continuous piece in a proprietary manufacturing process called Modified Monocoque Construction.


                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>         </div>
            </section>
        )
    }
}
function mapStateToProps (state){
    return {
        connection_id : state.tenant.connection_id,
        aboutAllContent : state.landing.aboutContent
    }
}

export default connect(mapStateToProps)(aboutAll)